import React from 'react';
import { Flex, Tag, Icon } from 'core/components';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import DeviceClassIcon from '../nms/DeviceClassIcon';

const ContextTag = styled(Tag)`
  padding: 4px;

  &.bp4-tag > .bp4-fill {
    display: flex;
    gap: 6px;
  }
`;

// Icon mapping based on context type
const getContextIcon = (context) => {
  switch (context.type) {
    case 'device':
      return <DeviceClassIcon fill primary iconSize={16} deviceModel={context.model} showTooltip />;
    case 'alert':
      return <Icon icon="shield" />;
    default:
      return <Icon icon="tag" />;
  }
};

const JourneysCopilotContextTags = ({ activeChatContext }) => {
  if (!activeChatContext || activeChatContext.size === 0) {
    return null;
  }

  return (
    <Flex alignItems="center" gap={1} mb={1}>
      {Array.from(activeChatContext).map((context) => (
        <ContextTag key={context.name} minimal intent="primary" round aria-label={`Context ${context.name}`}>
          {getContextIcon(context)}
          {context.name}
        </ContextTag>
      ))}
    </Flex>
  );
};

export default observer(JourneysCopilotContextTags);
